import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const INVOICE_DOWNLOAD_FORMATS_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator(
	'INVOICE_DOWNLOAD_FORMATS'
);
export const INVOICE_DOWNLOAD_FORMATS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	INVOICE_DOWNLOAD_FORMATS_CRUD_ACTION_CONSTANTS
);
